import app from "js/legacy-app";

app.controller("InsuranceVerificationCtrl", ['$scope', '$location', function ($scope, $location) {
    $scope.back = function() {
        $location.path('/dashboard?verification/');
    };
}]);